module.exports = __webpack_public_path__ + "assets/img/15-l.455986a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/15-l.jpg
// module id = ltP/
// module chunks = 0